var option_default = {
  "option": "_1UNuI",
  "user_choice": "wObV0",
  "check": "oO1QW",
  "image": "kMWK2",
  "input": "_8gJ9W",
  "title": "_7QSBh",
  "centered": "tcXT8",
  "with_result": "cD621",
  "list": "_5F7YL",
  "with_image": "HZoSF",
  "progress": "LsZaL",
  "progress_value": "cLvJW",
  "label": "SmZOk",
  "cta": "HJSr4",
  "adornment_icon": "yz8QH",
  "remove": "-HSKT",
  "removeButton": "cJavz",
  "removeButtonIcon": "ot7qK",
  "overlay": "QRzbO",
  "shown": "-voxy",
  "dark": "eV-vr",
  "spinner": "yFI01",
  "spin": "ryLNh"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
